import {utilHelper} from "../../_helpers";
import {SUCCESSFUL_TRANSLATION_LABEL} from "../../../components/i18n/i18n";

const relativeUrl = 'api/amenity'

export const amenityService = {
    getList,
    getItem,
    saveItem,
    updateItem,
    deleteItem,
    getAll,
    search,
    getAllByCategory,
    translate,
    getOptions
};

//index
function getList() {
    return utilHelper.doRequest(`${relativeUrl}`, 'GET')
}

//getAll
function getAll() {
    return utilHelper.doRequest(`${relativeUrl}/getAll`, 'GET')
}

//show
function getItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'GET')
}

//search
function search(offset, max, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data: data, showAlert: false })
}


//save
function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', { data: data });
}

//update
function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', { data: data });
}

//delete
function deleteItem(id, fbDB) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}/${fbDB}`, 'DELETE',{})
}

//show
function getAllByCategory(idCategory) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/getAllByCategory/${idCategory}`, 'GET', { showAlert:false })
}

function translate(id, data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/translate/${id}`, 'POST', { data: data, message:SUCCESSFUL_TRANSLATION_LABEL });
}

function getOptions(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/getOptions`, 'POST', { data:data, showAlert:false })
}